// @ts-nocheck
import { initialState } from "./reducer";

const myMessages = (state) => state.messages || initialState;

export const getMessages = (state) => myMessages(state).contactMessages;
